
export const SIGN_IN = '/signin';
export const HOME = '/';
export const ACCOUNT = '/account';
export const ADD_USER = '/adduser';
export const ADMIN = '/admin';
export const EDIT_USER = '/edit-user';
export const EDIT_MASTERDATA = '/edit-masterdata';
export const PASSWORD_FORGET = '/pw-forget';
export const ADD_CASE = '/addcase';
export const EDIT_CASE = '/editcase';
export const LEAD_CHECKS = '/lead-checks';
export const WEB_CHECKS = '/web-checks';
export const COMMENTS = '/comments';